export default __webpack_public_path__ + "static/media/tipping.8aad024f.png";